import { createSlice } from "@reduxjs/toolkit";


const initialState = {
    search: "",
    transactionType: "expense"
};

// create slice
const statementFilterSlice = createSlice({
    name: "statement",
    initialState,
    reducers: {
        searchFilter: (state, action) => {
            state.search = action.payload;
        },
        TransactionTypeFilter: (state, action) => {
            state.transactionType = action.payload;
        },
    },
});

export default statementFilterSlice.reducer;
export const { searchFilter, TransactionTypeFilter } = statementFilterSlice.actions;
